<template>
  <div>
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_title_addfood_manage_food">
          <img src="@/assets/fast-food.png">
        </div>
        <h2 class="title_addfood_manage_food">เพิ่มอาหาร</h2>
      </div>
      <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/managefood')">
        ย้อนกลับ
      </v-btn>
    </div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <v-divider/>
        <v-tabs grow>
          <v-tab @click="page(1)" style="font-size: 18px"><b>ข้อมูลอาหาร</b></v-tab>
          <v-tab @click="page(2)" style="font-size: 18px"><b>ผูกสูตรอาหาร</b></v-tab>
        </v-tabs>
        <v-divider/>
        <v-container v-if="page_menu === 1" >
          <v-form ref="form" @submit.prevent="addFood()">
            <v-row>
              <v-col cols="6">
                <div class="h_full_addfood_manage_food">
                  <v-img height="330" max-width="280" v-if="imagePreviewURL" :src="imagePreviewURL"></v-img>
                  <div>
                    <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="picture" label="เพิ่มรูปภาพอาหาร" @change="onFileChange"></v-file-input>
                    <div class="choose_more_addfood_manage_food">
                      ใส่รูปอาหารสวยๆช่วยให้ลูกค้าตัดสินใจสั่งอาหารง่ายขึ้น
                    </div>
                  </div>
                </div>

              </v-col>
              <v-col cols="6">
                <div class="d-flex justify-center align-center h_full_addfood_manage_food">
                  <v-select label="ประเภทอาหาร" :items="type_food_list" item-text="name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกประเภทอาหาร']" required v-model="type_food_id" outlined>
                  </v-select>
                </div>

              </v-col>

              <v-col cols="6">
                <v-text-field label="ชื่ออาหารภาษาไทย" :rules="[v => !!v || 'กรุณากรอกชื่ออาหารภาษาไทย']" required v-model="name" outlined></v-text-field>
                <v-text-field label="ราคาอาหาร" :rules="[v => !!v || 'กรุณากรอกราคาอาหาร']" required type="number" v-model="price" outlined></v-text-field>
                <!-- <div class="d-flex check_type_full_addfood_manage_food">
                    <v-checkbox color="primary" class="ma-0" v-model="dine_in"></v-checkbox>
                    <div>ไม่แสดงอาหารนี้ในเมนู อลาคาส เมื่อเปิดโต๊ะบุฟเฟ่ต์</div>
                </div> -->
                <div class="d-flex check_type_full_addfood_manage_food">
                  <v-checkbox color="primary" class="ma-0" v-model="status_show_customer"></v-checkbox>
                  <div>ไม่แสดงอาหารนี้ในเมนู ของลูกค้า</div>
                </div>
              </v-col>
              <v-col cols="6">
                <v-text-field label="ชื่ออาหารอังกฤษ" :rules="[v => !!v || 'กรุณากรอกชื่ออาหารภาษาอังกฤษ']" required v-model="name_eng" outlined></v-text-field>
                <div>หมวดอาหาร <span class="choose_more_addfood_manage_food">( สามารถเลือกได้มากกว่า 1 )</span></div>

                <!-- <div class="d-flex">
                    <div class="d-flex check_type_addfood_manage_food">
                        <v-checkbox color="primary" class="ma-0" v-model="buffet"></v-checkbox>
                        <div>บุฟเฟ่ต์</div>
                    </div>
                    <div class="d-flex check_type_addfood_manage_food">
                        <v-checkbox color="primary" class="ma-0" v-model="buyback"></v-checkbox>
                        <div>ซื้อกลับบ้าน</div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="d-flex check_type_addfood_manage_food">
                        <v-checkbox color="primary" class="ma-0" v-model="plate"></v-checkbox>
                        <div>ทานที่ร้าน</div>
                    </div>
                    <div class="d-flex check_type_addfood_manage_food">
                        <v-checkbox color="primary" class="ma-0" v-model="drink"></v-checkbox>
                        <div>เครื่องดื่ม</div>
                    </div>
                </div> -->
                <div class="d-flex">
                  <div class="d-flex check_type_addfood_manage_food">
                    <v-checkbox color="primary" class="ma-0" v-model="plate"></v-checkbox>
                    <div> ทานที่ร้าน</div>
                  </div>
                  <div class="d-flex check_type_addfood_manage_food">
                    <v-checkbox color="primary" class="ma-0" v-model="buyback"></v-checkbox>
                    <div>ซื้อกลับบ้าน</div>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="d-flex check_type_addfood_manage_food">
                    <v-checkbox color="primary" class="ma-0" v-model="drink"></v-checkbox>
                    <div>เครื่องดื่ม</div>
                  </div>
                </div>

              </v-col>
              <v-col cols="12">
                <v-text-field label="รายละเอียดโดยย่อ" v-model="sub_title" outlined></v-text-field>
                <v-textarea outlined label="รายละเอียดอาหาร" v-model="description"></v-textarea>
                <div>ท็อปปิ้ง <span class="choose_more_addfood_manage_food">( สามารถเลือกได้มากกว่า 1 )</span></div>
                <v-card class="mt-2" v-for="(topping_detail,key) in topping_list" :key="key">
                  <div class="pa-3 d-flex align-center">
                    <v-checkbox color="primary" v-model="topping" :value="topping_detail.id"></v-checkbox>
                    <div>
                      <div>{{ topping_detail.topingcategories_name }}</div>
                      <div>
                                            <span v-for="(detail,key_detail) in topping_detail.toping_list" :key="key_detail">
                                                {{ detail.name }}<span v-if="key_detail != Object.keys(topping_detail.toping_list).length - 1">, </span>
                                            </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-btn color="#28ab28" class="titlefont_addfood_manage_food white--text" type="submit" height="50" width="100%">
                  บันทึก
                </v-btn>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-container v-else>
          <v-form ref="form" @submit.prevent="addFood()">
            <v-row class="mt-3">
              <v-col cols="12">
                <div class="d-flex">
                  <div class="pr-2"><b>การผูกสูตรอาหาร</b></div>
                  <div class="grey--text">(สามารถเพิ่มได้หลายวัตถุดิบ)</div>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="mt-n1 mr-1">
                  <v-autocomplete :items="list_menu" item-text="name" item-value="id" @input="add_material(material_id)" v-model="material_id" prepend-inner-icon="mdi-magnify" label="เลือกวัตถุดิบ" hide-details="auto" outlined></v-autocomplete>
                </div>
              </v-col>
              <v-col>
                <div>
                  <v-data-table :headers="material_header" :items="data_list" :items-per-page="-1" mobile-breakpoint="0" hide-default-footer>
                    <template slot="item" slot-scope="dataDetail">
                      <tr class="text-center">
                        <td>
                          <v-btn color="red" small height="42" class="white--text mb-1" @click="getDelete(dataDetail.item.loop_id)">
                            <v-icon>mdi-window-close</v-icon>
                          </v-btn>
                        </td>
                        <td>{{ dataDetail.item.name }}</td>
                        <td class="pa-3">
                          <v-text-field type="number" min="0" :rules="[v => !!v || 'กรุณากรอกจำนวน']" @keypress="onlyForCurrency($event, dataDetail.item.material_input)" v-model="dataDetail.item.material_input" hide-details="auto" outlined></v-text-field>
                        </td>
                        <td>{{ dataDetail.item.unit_name }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-divider/>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-btn color="#28ab28" class="titlefont_addfood_manage_food white--text" type="submit" height="50" width="100%">
                  บันทึก
                </v-btn>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
      <v-dialog v-model="alert_show_add" persistent max-width="600">
        <v-card>
          <v-card-title>
            สำเร็จ
          </v-card-title>

          <v-card-text>
            เพิ่มอาหารเรียบร้อย
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="confirmSuccess()">
              ตกลง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="alert_error" persistent max-width="600">
        <v-card>
          <v-card-title>
            คำเตือน
          </v-card-title>

          <v-card-text>
            กรุณาเลือกหมวดอาหารอย่างน้อย 1 ตัวเลือก
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="alert_error = false">
              ตกลง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="alert_receipt_error" persistent max-width="600">
        <v-card>
          <v-card-title>
            คำเตือน
          </v-card-title>

          <v-card-text>
            กรุณาผูกสูตรอาหาร
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="alert_receipt_error = false">
              ตกลง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script><script>
import {
  HTTP
} from "@/axios.js"
import before_image from "@/assets/fast-food.png";

export default {
  name: 'addFood',
  data() {
    return {
      loading_page: true,
      alert_receipt_error: false,
      imagePreviewURL: before_image,
      type_food_list: [],
      topping_list: [],
      picture: null,
      type_food_id: null,
      name: null,
      name_eng: null,
      price: null,
      dine_in:false,
      status_show_customer:false,
      buffet: false,
      buyback: false,
      plate: false,
      drink: false,
      sub_title: null,
      description: null,
      topping: [],
      alert_show_add: false,
      alert_error: false,
      page_menu: 1,
      list_menu: [],
      material_id: null,
      material_header: [
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
          align: 'center',
        },
        {
          text: 'วัตถุดิบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '250px',
          align: 'center',
        },
        {
          text: 'จำนวน',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px',
          align: 'center',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px',
          align: 'center',
        },
      ],
      data_list: [],
      loop_id: 0,
    }
  },
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  methods: {
    onlyForCurrency(evt, number) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
      // restrict to 2 decimal places
      else if (number !== null && number.indexOf(".") > -1 && (number.split('.')[1].length >= 2)) {
        evt.preventDefault();
      } else {
        return true
      }
    },
    page(page_number) {
      this.page_menu = page_number
    },
    async onFileChange(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURL = before_image
      }
    },
    async getData() {
      await this.typeFoodList()
      await this.toppingList()
    },
    async add_material(mat_id) {
      let value = this.list_menu.find((res) => {
          return res.id === mat_id
      })
      this.list_menu = this.list_menu.filter((res) => {
          return res.id != mat_id
      })

      this.loop_id += 1
      this.data_list.push({
          loop_id: this.loop_id,
          id: value.id,
          unit_id: value.unit_id,
          name: value.name,
          material_input: null,
          unit_name: value.unit_name,
      })

      await this.$nextTick(() => {
          this.material_id = null
      })

    },
    async getDelete(loop_id) {
      const value = this.data_list.find((detail) => {
          return detail.loop_id === loop_id
      })
      this.list_menu.push({
          id: value.id,
          name: value.name,
          unit_id: value.unit_id,
          unit_name: value.unit_name,
      })
      this.data_list = this.data_list.filter(detail => detail.loop_id != loop_id)
      this.list_menu.sort((a, b) => {
          let fa = a.name.toLowerCase(),
              fb = b.name.toLowerCase();

          if (fa < fb) {
              return -1;
          }
          if (fa > fb) {
              return 1;
          }
          return 0;
      })
      this.material_id = null
    },
    async typeFoodList() {
      HTTP.get('/food/categories/list', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              this.type_food_list = response.data.foodCategories
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async toppingList() {
      HTTP.get('/toping/categories-list', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              this.topping_list = response.data.topingcategories
              this.loading_page = false
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async receipt() {
      HTTP.get('/bom/searchMat', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      }).then((response) => {
        if (response.data.successful === true) {
          this.list_menu = response.data.mat
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async addFood() {
      if (this.$refs.form.validate()) {
        this.loading_page = true
        let selectType = false
        let data = new FormData()
        data.append('picture', this.picture)
        data.append('foodcategories_id', this.type_food_id)
        data.append('name', this.name.replace(this.$store.state.checkEmoji, ""))
        data.append('nameEng', this.name_eng)
        data.append('price', this.price)
        data.append('dine_in', '')
        data.append('status_show_customer', '')

        this.data_list.forEach((detail) => {
          data.append('mat_id[]', detail.id)
          data.append('use_in[]', detail.material_input)
          data.append('unit_id[]', detail.unit_id)
        });

        if (this.dine_in === true) {
          data.append('dine_in', 1)
        }

        if (this.status_show_customer === true) {
          data.append('status_show_customer', 1)
        }

        data.append('buffet', '')
        if (this.buffet === true) {
          data.append('buffet', 1)
          selectType = true
        }
        data.append('buyback', '')
        if (this.buyback === true) {
          data.append('buyback', 1)
          selectType = true
        }
        data.append('plate', '')
        if (this.plate === true) {
          data.append('plate', 1)
          selectType = true
        }
        data.append('drink', '')
        if (this.drink === true) {
          data.append('drink', 1)
          selectType = true
        }
        if (this.sub_title === "" || this.sub_title === null) {
          data.append('sub_title', null)
        } else {
          data.append('sub_title', this.sub_title)
        }
        if (this.description === "" || this.description === null) {
          data.append('description', null)
        } else {
          data.append('description', this.description)
        }

        data.append('topingcategories_id', this.topping.sort().toString())
        if (selectType) {
          HTTP.post('/food/menu/create', data, {
            headers: {
              "Authorization": `Bearer ${this.$store.state.token}`
            }
          })
              .then((response) => {
                if (response.data.successful === true) {

                  this.alert_show_add = true
                  this.loading_page = false
                }

              }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
        }
        if (!selectType) {
          this.alert_error = true
          this.loading_page = false
        }
      }
    },
    async confirmSuccess() {
      this.$router.push('/managefood')
    }
  },
  mounted() {
    this.page(1)
    this.receipt()
    this.getData()
  },
}
</script>
